<template>
  <b-navbar id="top-nav-bar" class="sticky-top" toggleable="lg">
    <b-navbar-brand href="#" @click.prevent="redirectToTradeRoom">
      <img
        height="35"
        :src="logoSrc"
        :alt="logoText"
        class="logo"
        :class="{ 'logo-small': useSmallLogo }"
      />
    </b-navbar-brand>

    <b-navbar-nav class="d-flex">
      <div
        ref="menu"
        :class="
          $mq !== 'desktop'
            ? 'hamburger-menu-container'
            : 'navbar-menu-container'
        "
      >
        <span class="navbar-menu-item" :class="{ active: stkType === '1' }">
          <div class="navbar-router-link text-medium-sm">
            <router-link class="navbar-router-link" :to="{ name: 'trade-ipo' }">{{
              $t("trade.type.primary")
            }}</router-link>
          </div>
          <div class="navbar-special navbar-item-border"></div>
        </span>
        <span
          class="navbar-menu-item mr-5"
          :class="{ active: stkType === '2' }"
        >
          <div
            @click.stop="
              changeStockType('2');
              typeTitle = $t('trade.type.secondary');
            "
            class="navbar-router-link text-medium-sm"
          >
            {{ $t("trade.type.secondary") }}
          </div>
          <div class="navbar-special navbar-item-border"></div>
        </span>
      </div>
      <div
        v-if="$mq === 'desktop'"
        class="d-flex fav-brands-container"
        ref="favItemContainer"
      >
        <fav-item
          v-for="(item, i) in favoriteBrands"
          :key="i"
          :item="item"
          :brand="brand"
          :removeFav="removeFav"
        />
      </div>
    </b-navbar-nav>

    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto user-menu">
      <div class="user-right-menu">
        <div class="menu-item menu-special">
          <router-link class="balance-button" :to="{ name: 'balance' }">
            <div
              class="top-button"
              v-b-tooltip.bottom
              :title="$t('account.account-info')"
            >
              <span class="balance" v-if="$mq === 'desktop'">
                <masked-amount>
                  <template #visible>
                    {{ localBalanceValue | currency }}
                  </template>
                </masked-amount>
              </span>
              <i class="sr sr-wallet"></i>
            </div>
          </router-link>
        </div>
        <div class="menu-item menu-special">
          <button
            type="button"
            class="btn top-button balance-visibility-button"
            v-b-tooltip.bottom
            :title="balanceVisibilityTitle"
            :aria-label="balanceVisibilityTitle"
            @click.prevent="toggleBalanceVisibility"
          >
            <i
              :class="balanceVisible ? 'sr sr-eye-open' : 'sr sr-ey-close'"
            ></i>
          </button>
        </div>
               <!-- TODO түр нуув. Дараагийн өөрчлөлтөөр үндсэн болгоно -->
               <div class="menu-item border-left menu-special" @click="toggleNotify" id="notify">
                 <div class="top-button"
                      v-b-tooltip.bottom
                      :title="$t('account.notification')">
                   <i class="sr sr-bell"> <span v-if="this.notifCount>0" class="badge badge-danger" style="font-size: 8px; position: absolute">{{this.notifCount}}</span></i>
                 </div>
                 <transition name="fade">
                   <div v-show="openedNotif"
                        class="profile-container"
                        id="profile-trigger" style="max-height: 80vh; overflow-y: scroll">
                     <div class="blocker"></div>
                     <div class="profile-sub-container">
                       <template v-if="notifs.length">
                         <div v-for="item in notifs" :key="item.id">
                           <div class="profile-row" @click="seenNotif(item.id)">
                               {{ item.body }}
                           </div>
                         </div>
                       </template>
                       <div v-else class="profile-row text-center">
                         {{ $t('account.no-notification') }}
                       </div>
                     </div>
                   </div>
                 </transition>
               </div>
        <div
          v-if="isAuthenticated"
          class="menu-item border-left menu-special"
          id="profile"
          @click="toggleProfile"
        >
          <div class="top-button" v-b-tooltip.bottom :title="$t('user.info')">
            <i class="sr sr-user"></i>
          </div>
          <transition name="fade">
            <div
              v-show="openedProfile"
              class="profile-container"
              id="profile-trigger"
            >
              <div class="blocker" @click="toggleProfile"></div>
              <div class="profile-sub-container">
                <div class="header">
                  <div class="email" v-if="user">
                    {{
                      user?.lastname
                        ? user.lastname + " " + user.firstname
                        : user.email
                    }}
                  </div>
                </div>
                <div class="profile-row">
                  <router-link
                    :to="{ name: 'user-detail' }"
                    class="profile-item"
                  >
                    <i class="sr sr-user"></i>
                    {{ $t("user.profile") }}
                  </router-link>
                  <div @click="logOut" class="profile-footer text-center">
                    {{ $t("user.logout") }}
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="menu-item border-left">
          <theme-toggle />
        </div>
        <div class="menu-item border-left">
          <button type="button" class="btn top-button" @click="toggleLang">
            {{ $i18n.locale.toUpperCase() }}
          </button>
        </div>
      </div>
      <div
        v-if="$mq !== 'desktop'"
        class="menu-item menu-special hamburger border-left"
        id="burger-menu"
      >
        <button @click.prevent="toggleHamburger" class="btn top-button">
          <i v-if="dark" class="sr sr-menu-hamburger text-white"></i>
          <i v-else class="sr sr-menu-hamburger"></i>
        </button>
      </div>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
// eslint-disable-next-line
import _ from "lodash";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import ThemeToggle from "../ThemeToggle";
import FavItem from "../FavItem";
import MaskedAmount from "../global/MaskedAmount";
import api from "../../api/stoTrade";
import axios from "axios";
import LOGO from "../../constants/logo";

const stypeName = {
  1: "Хувьцаа",
  2: "Компанийн бонд",
  3: "Засгийн газрын бонд",
};

export default {
  name: "topbar",
  components: {
    "theme-toggle": ThemeToggle,
    "fav-item": FavItem,
    MaskedAmount,
  },
  data() {
    return {
      loading: {
        localBalance: false,
        brands: false,
      },
      scrollPos: 0,
      theme: "",
      stypeName,
      brandSearchQuery: null,
      // brands: [],
      ipoList: [],
      selectedBrand: null,
      page: 1,
      brandListLastPage: 1,

      // STATES FOR POPUP
      openedBrands: false,
      openedProfile: false,
      openedBalance: false,
      openedNotif: false,
      errors: [],
      stkType: "2",
      typeTitle: `${this.$t("trade.type.secondary")}`,
      hamburgerToggle: false,
      // Image
      lightImageUrl: LOGO.light,
      darkImageUrl: LOGO.dark,
      smallLightImageUrl: LOGO.smallLight,
      smallDarkImageUrl: LOGO.smallDark,
      logoText: LOGO.text,
    };
  },
  created() {
    if (this.$route.name === "trade-sto") {
      this.setStockType(2);
      this.stkType = "2";
    } else if (this.$route.name === "trade-ipo") {
      this.setStockType(1);
      this.stkType = "1";
    }
    this.fetchFavBrands();
    this.fetchFcmToken();
    this.fetchUnreadNotifs();
  },
  async mounted() {
    this.stkType = this.stockType;
    document.addEventListener("click", this.close);
    document.addEventListener("click", this.closeNotif);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
    document.removeEventListener("click", this.closeNotif);
  },
  methods: {
    ...mapActions("brand", [
      "setBrand",
      "setFavoriteBrands",
      "clearBrand",
      "setStockType",
      "fetchFavBrands",
    ]),
    ...mapActions("common", ["toggleSbNavState", "toggleBalanceVisibility"]),
    ...mapActions("user", ["fetchUnreadNotifs", "fetchFcmToken", "seenNotif"]),
    startScrolling() {
      if (!this.$mq || this.favoriteBrands.length === 0) return;
      if (typeof this.$refs.favItemContainer === "undefined") return;
      if (
        this.$refs.favItemContainer.scrollHeight >=
        this.$refs.favItemContainer.clientHeight * 2
      ) {
        this.scrollInterval = setInterval(() => {
          this.$refs.favItemContainer.scrollTo({
            top: this.scrollPos,
            behavior: "smooth",
          });
          if (this.scrollPos >= this.$refs.favItemContainer.scrollHeight) {
            this.scrollPos = 0;
          } else {
            this.scrollPos += this.$refs.favItemContainer.clientHeight;
          }
        }, 2000);
      }
    },
    async toggleSideBar() {
      this.toggleSbNavState();
    },
    async logOut() {
      this.$store.dispatch("auth/logout");
      this.$store.dispatch("enuduser/socket/logout");
    },
    changeStockType(type) {
      if (type !== "3") {
        this.$router.push({ name: type === "1" ? "trade-ipo" : "trade-sto" });
        // console.log(this.stkType);
        // console.log(type);
        // if (this.stkType === '2' || this.stkType === '1') this.clearBrand();
      }
      this.setStockType(type);
      // if (this.stockType === 1 && this.$route.name === 'sto') this.$router.push({ name: 'ipo' });
      // else this.$router.push({ name: 'sto' });
      //this.clearBrand();
    },
    redirectToTradeRoom() {
      this.$router.push({
        name: this.stockType === "1" ? "trade-ipo" : "trade-sto",
      });
    },
    toSymbolName(symbol) {
      if (!symbol) return;
      return !symbol.split("").includes("-")
        ? symbol
        : symbol
            .split("")
            .splice(
              0,
              symbol.split("").findIndex((x) => x === "-"),
            )
            .join("")
            .toString();
    },
    toggleBrandList() {
      this.openedBrands = !this.openedBrands;
    },
    openBrand(brand) {
      document.getElementById(`fav-item-${brand.symbol}`).blur();
      this.selectedBrand = brand;
      this.setBrand(brand);
      this.$forceUpdate();
    },
    async addFav(brand) {
      if (this.favoriteBrands.length >= 7) {
        this.$bvToast.toast(
          this.$t("reached-limit-of-fav-item", { limit: 7 }),
          {
            variant: "warning",
            title: this.$t("warning.title"),
          },
        );
        return;
      }
      try {
        await api.addFavoriteBrand({
          symbol: brand.symbol,
          company_symbol_name: brand.company_name,
        });
        this.setBrand(brand);
        this.brands.find((x) => x.symbol === brand.symbol).isDisabled = true;
        this.favoriteBrands.push(
          this.brands.find((x) => x.symbol === brand.symbol),
        );
        this.openedBrands = !this.openedBrands;
      } catch (e) {
        console.error(e);
      }
    },
    async removeFav(symbol) {
      try {
        await api.removeFavoriteBrand({ symbol });
        this.fetchFavBrands();
      } catch (e) {
        console.error(e);
      }
    },
    close(e) {
      var container = document.getElementById("profile");
      if (typeof container === "undefined" || container === null) return;
      if (!container.contains(e.target)) {
        this.openedProfile = false;
      }
      var container2 = document.getElementById("burger-menu");
      if (typeof container2 === "undefined" || container2 === null) return;
      if (!container2.contains(e.target)) {
        this.hamburgerToggle = false;
        this.$refs.menu.classList.remove("hamburger-show");
      }
    },
    closeNotif(e) {
      var container = document.getElementById("notify");
      if (typeof container === "undefined" || container === null) return;
      if (!container.contains(e.target)) {
        this.openedNotif = false;
      }
    },
    toggleProfile() {
      this.openedProfile = !this.openedProfile;
    },
    toggleNotify() {
      this.openedNotif = !this.openedNotif;
    },
    stypeVariant(type) {
      switch (type) {
        case 1:
          return "info";
        case 2:
          return "success";
        case 3:
          return "warning";
      }
    },
    toggleHamburger() {
      this.hamburgerToggle = !this.hamburgerToggle;
      if (this.hamburgerToggle === true) {
        this.$refs.menu.classList.add("hamburger-show");
      } else {
        this.$refs.menu.classList.remove("hamburger-show");
      }
    },
    toggleLang() {
      const langs = ["mn", "en"];
      const current = this.$i18n.locale;
      const next = langs[(langs.indexOf(current) + 1) % langs.length];
      this.$i18n.locale = next;
      window.localStorage.setItem("_lang", next);
    },
  },
  computed: {
    ...mapState("brand", ["stockType", "brand", "favoriteBrands"]),
    ...mapState("common", ["dark", "sbNavState", "balanceVisible"]),
    ...mapState("user", ["user", "unreadNotifs", "unreadNotifCount"]),
    ...mapGetters(["localBalance"]),
    ...mapGetters("auth", ["isAuthenticated"]),
    useSmallLogo() {
      const smallUrl = this.dark ? this.smallLightImageUrl : this.smallDarkImageUrl;
      return this.$mq !== "desktop" && !!smallUrl;
    },
    logoSrc() {
      if (this.useSmallLogo) {
        return this.dark ? this.smallLightImageUrl : this.smallDarkImageUrl;
      }
      return this.dark ? this.darkImageUrl : this.lightImageUrl;
    },
    balanceVisibilityTitle() {
      return this.balanceVisible
        ? this.$t("account.hide-balances")
        : this.$t("account.show-balances");
    },
    localBalanceValue() {
      if (
        this.localBalance === null ||
        this.localBalance === undefined ||
        this.localBalance === ""
      ) {
        return 0;
      } else {
        return this.localBalance.availableBalance;
      }
    },
    removeButtonVisibility() {
      return this.favoriteBrands && this.favoriteBrands.length && this.isSto;
    },
    isSto() {
      return this.stockType === "2";
    },
    isIpo() {
      return this.stockType === "1";
    },
    notifs() {
      return this.unreadNotifs;
    },
    notifCount() {
      return this.unreadNotifCount;
    },
  },
  watch: {
    favoriteBrands: function (newBrands, oldBrands) {
      this.scrollPos = 0;
      this.startScrolling();
    },
    stockType: {
      handler(newType, oldType) {
        if (
          (newType === "1" && oldType === "2") ||
          (newType === "2" && oldType === "1")
        ) {
          this.clearBrand();
        }
        return newType;
      },
    },
    $route: {
      handler(val) {
        if (val.meta.isOther) {
          this.setStockType("3");
          this.stkType = "3";
        } else {
          let type = this.$route.name === "trade-sto" ? "2" : "1";
          this.setStockType(type);
          this.stkType = type;
        }
      },
    },
    "$route.name"(val) {
      this.openedProfile = false;
    },
  },
};
</script>
<style lang="scss" src="./Topbar.scss"></style>
